import { ENDPOINT } from '~/constants';

import { isAbortError, type KyRequestOptions } from '@vestigas/data';

import { vestigasAiApi } from '~/services/kyClient';

import { log } from '~/utils';

import {
  type FilteredProjectsQueryParameters,
  type FilteredProjectsResponse,
} from './types';
import { zodFilteredProjectsQueryParametersSchema } from './validations';

/**
 * Fetches all AI projects (folders from blob storage) filtered by type from the API.
 * Cached on the server for 30 minutes with background refresh.
 * @param queryParameters - The query parameters to fetch the AI projects.
 * @param options - Request options.
 * @returns The filtered AI projects.
 * @see https://fa-vestigas-dev.azurewebsites.net/docs#/Metadata/get_filtered_projects_get_projects_get
 */
export const fetchFilteredProjects = async (
  queryParameters: FilteredProjectsQueryParameters,
  options?: KyRequestOptions,
) => {
  try {
    const response = await vestigasAiApi
      .get(ENDPOINT.AI.GET_FILTERED_PROJECTS(), {
        searchParams: queryParameters,
        validate: {
          searchParams: zodFilteredProjectsQueryParametersSchema,
        },
        ...options,
      })
      .json<FilteredProjectsResponse>();

    return response;
  } catch (error) {
    if (isAbortError(error)) {
      return;
    }

    log.error({
      message: 'Error fetching filtered AI projects',
      error,
    });

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
